const schools = {
  nantun: "南屯校",
  west1: "西區校  國⼩部",
  west2: "西區校  國中部/高中部",
  xitun: "西屯校",
  "west-first": "西區校  國⼩部",
  "west-second": "西區校  國中部/高中部",
  "west-second-B": "西區校  國中部/高中部B棟"
};

export const getSchoolName = key => {
  return schools[key];
};

export const getSchoolKey = name => {
  return Object.keys(schools).find(key => schools[key] == name);
};
